import PasswordChange from '../Auth/PasswordChange'
import Register from '../Auth/Register'
import RegisterSuccess from '../Auth/RegisterSuccess'
import Home from '../Home/Home'
import Invoices from '../Invoices/Invoices'
import Shipments from '../Shipments/Shipments'
import ShipmentHandle from '../Shipments/ShipmentHandle'
import ShipmentView from '../Shipments/ShipmentView'
import Documents from '../Documents/Documents'
import Reports from '../Reports/Reports'
import Login from '../Auth/Login'
import PasswordReset from '../Auth/PasswordReset'
import ProfileEdit from '../Profile/ProfileEdit'
import Releases from '../Releases/Releases'
import ReleaseHandle from '../Releases/ReleaseHandle'
import ReleaseView from '../Releases/ReleaseView'
import ShippingDocumentHandle from '../ShippingDocuments/ShippingDocumentHandle'
import ShippingDocuments from '../ShippingDocuments/ShippingDocuments'
import ShippingDocumentView from '../ShippingDocuments/ShippingDocumentView'

export const appRoutes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipping-documents',
    name: 'shipping.documents',
    component: ShippingDocuments,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipping-document/:id/edit',
    name: 'shipping.document.edit',
    component: ShippingDocumentHandle,
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipping-document-create',
    name: 'shipping.document.create',
    component: ShippingDocumentHandle,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipping-document/:id/view',
    name: 'shipping.document.view',
    component: ShippingDocumentView,
    meta: {
      auth: true
    }
  },
  {
    path: '/releases',
    name: 'Releases',
    component: Releases,
    meta: {
      auth: true
    }
  },
  {
    path: '/release/:id/edit',
    name: 'releases.edit',
    component: ReleaseHandle,
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/release/:id/view',
    name: 'releases.view',
    component: ReleaseView,
    meta: {
      auth: true
    }
  },
  {
    path: '/release-create',
    name: 'release.create',
    component: ReleaseHandle,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipments',
    name: 'Shipments',
    component: Shipments,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipments/:id/edit',
    name: 'shipments.edit',
    component: ShipmentHandle,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipments/:id/view',
    name: 'shipments.view',
    component: ShipmentView,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipments-create',
    name: 'shipments.create',
    component: ShipmentHandle,
    meta: {
      auth: true
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents
  },
  /*{
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      auth: true
    }
  },*/
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      auth: false
    }
  },
  {
    path: '/registersuccess',
    name: 'registersuccess',
    component: RegisterSuccess,
    meta: {
      auth: false
    }
  },
  {
    path: '/password-reset',
    name: 'password.reset',
    component: PasswordReset,
    meta: {
      auth: false
    }
  },
  {
    path: '/password-change',
    name: 'password.change',
    component: PasswordChange,
    meta: {
      auth: false
    }
  },
  {
    path: '/profile-edit',
    name: 'profile-edit',
    component: ProfileEdit,
    meta: {
      auth: true
    }
  }
]
